import { createAction } from 'redux-actions';


export const clear = createAction('REGISTRATION:SERVICE_PROVIDER:CLEAR');

export const updateOrgName = createAction('REGISTRATION:SERVICE_PROVIDER:UPDATE_ORG_NAME', ({orgName}) => ({orgName}));

export const updateOrgPhone = createAction(
  'REGISTRATION:SERVICE_PROVIDER:UPDATE_ORG_PHONE',
  ({orgPhone}) => ({orgPhone})
);

export const updateOrgEmail = createAction(
  'REGISTRATION:SERVICE_PROVIDER:UPDATE_ORG_EMAIL',
  ({orgEmail}) => ({orgEmail})
);

export const updateUserEmail = createAction('REGISTRATION:SERVICE_PROVIDER:UPDATE_USER_EMAIL',
  ({userEmail}) => ({userEmail}));

export const updateUserGivenName = createAction('REGISTRATION:SERVICE_PROVIDER:UPDATE_USER_GIVEN_NAME',
  ({userGivenName}) => ({userGivenName}));

export const updateUserFamilyName = createAction('REGISTRATION:SERVICE_PROVIDER:UPDATE_USER_FAMILY_NAME',
  ({userFamilyName}) => ({userFamilyName}));


// WEBPACK FOOTER //
// ./src/actions/registration/serviceProvider.js